// Writes survive section/page unmount. Serial ordering also orders the database
// commits; merely ignoring old HTTP responses cannot do that. No values cached.
const pending = new Map()
export function enqueueSportWrite(scope, write) {
  const previous = pending.get(scope)
  const next = previous ? previous.catch(() => {}).then(write) : Promise.resolve(write())
  pending.set(scope, next)
  next.finally(() => { if (pending.get(scope) === next) pending.delete(scope) }).catch(() => {})
  return next
}
export async function waitForSportWrites(scope) {
  while (pending.has(scope)) await pending.get(scope).catch(() => {})
}
